import * as type from '@/store/types'
import { throwError } from '@/utils/store'
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  LOCAL_PROMPT_KEY,
  DIRECT_LOGIN,
  saveStorageItem,
  removeStorageItem
} from '@/utils/storage'
import { USER_AUTHORITIES, ADMIN_AUTHORITIES } from '@/utils/authorities'
import i18n from '@/plugins/i18n'

export default {
  [type.CREATE_SESSION_WITH_CODE]: ({ commit, getters }, { code }) => {
    const name = type.SESSION
    commit(type.LOADING, name)
    return getters.apiService
      .createSessionWithCode({ code })
      .then((model) => {
        commit(type.SET_MODEL, {
          name,
          model: {
            ...model,
            currentlyViewProfile: null,
            firstLogin: false,
            authorities: [...USER_AUTHORITIES]
          }
        })

        saveStorageItem(ACCESS_TOKEN, model.access)
        saveStorageItem(REFRESH_TOKEN, model.refresh)
      })
      .catch(throwError(commit, 'Ошибка создания сессии пользователя с помощью Yandex'))
      .finally(() => commit(type.LOADED, name))
  },

  [type.CREATE_SESSION_FOR_VIEW]: ({ commit, getters }, { profileId, firstLogin }) => {
    const name = type.SESSION

    commit(type.LOADING, name)
    return getters.apiService
      .createSessionForView()
      .then((model) => {
        commit(type.UPDATE_MODEL, {
          name,
          model: {
            ...model,
            currentlyViewProfile: profileId,
            firstLogin,
            authorities: [...ADMIN_AUTHORITIES]
          }
        })
      })
      .catch(throwError(commit, 'Ошибка создания сессии для просмотра профиля'))
      .finally(() => commit(type.LOADED, name))
  },

  [type.RESET_SESSION]: ({ commit }) => {
    const name = type.SESSION

    commit(type.UPDATE_MODEL, {
      name,
      model: {
        access: null,
        refresh: null,
        user: {
          directLogin: null
        }
      }
    })
  },

  [type.REFRESH_SESSION]: ({ state, commit, getters }) => {
    const { refresh } = state[type.SESSION].model
    const name = type.SESSION

    commit(type.LOADING, name)
    return getters.apiService
      .refreshSession({ refresh })
      .then((model) => {
        commit(type.UPDATE_MODEL, { name, model })

        // TODO: избавиться при удалении флага (при реализации authorities)
        if (!getters.isViewSession) {
          saveStorageItem(ACCESS_TOKEN, model.access)
          saveStorageItem(REFRESH_TOKEN, model.refresh)
        }
      })
      .catch(throwError(commit, 'Ошибка обновления сессии пользователя'))
      .finally(() => commit(type.LOADED, name))
  },

  [type.REMOVE_SESSION]: ({ commit, getters }) => {
    const name = type.SESSION
    const model = {
      access: null,
      refresh: null,
      id: null,
      user: {
        userId: null,
        directLogin: null,
        directDataUpdatedAt: null,
        email: null,
        username: null
      },
      currentlyViewProfile: null,
      firstLogin: false,
      authorities: [],
      accounts: []
    }

    commit(type.SET_MODEL, { name, model })

    // TODO: избавиться при реализации authorities
    if (!getters.isViewSession) {
      removeStorageItem(ACCESS_TOKEN)
      removeStorageItem(REFRESH_TOKEN)
      removeStorageItem(DIRECT_LOGIN)
    }
  },

  [type.SET_LOCAL_PROMPT]: ({ commit }, { value }) => {
    commit(type.SET_MODULE_PROPERTY, {
      name: type.SESSION,
      key: 'prompt',
      value
    })

    saveStorageItem(LOCAL_PROMPT_KEY, value)
  },

  [type.REMOVE_LOCAL_PROMPT]: ({ commit }) => {
    commit(type.SET_MODULE_PROPERTY, {
      name: type.SESSION,
      key: 'prompt',
      value: null
    })

    removeStorageItem(LOCAL_PROMPT_KEY)
  },

  [type.GET_SESSION_ACCOUNT]: ({ commit, getters }) => {
    const name = type.SESSION

    commit(type.LOADING, name)
    return getters.apiService
      .getSessionAccount()
      .then((user) => {
        if (user) {
          if (getters.isViewSession) {
            const authorities = [...ADMIN_AUTHORITIES]
            commit(type.UPDATE_MODEL, { name, model: { user, authorities } })
          } else {
            if (user.directLogin) {
              saveStorageItem(DIRECT_LOGIN, user.directLogin)
            }

            const authorities = [...USER_AUTHORITIES]
            commit(type.UPDATE_MODEL, { name, model: { user, authorities } })
          }
        } else {
          throwError(commit, 'Ошибка: отсутствует пользователь в ответе сервера')
        }
      })
      .catch(throwError(commit, 'Ошибка получения сессии'))
      .finally(() => commit(type.LOADED, name))
  },

  // Получение списка аккаунтов Яндекс.Директ
  [type.GET_ACCOUNT_LIST]: ({ getters, commit, dispatch }) => {
    const name = type.SESSION
    dispatch(type.LOADING_DATA, i18n.t('c.loading.messageFetchingAccountList'))

    commit(type.LOADING, name)
    return getters.apiService
      .getAccountList()
      .then((model) => {
        commit(type.UPDATE_MODEL, { name, model })
      })
      .catch(throwError(commit, 'Ошибка получения списка аккаунтов'))
      .finally(() => {
        commit(type.LOADED, name)
        dispatch(type.LOADED_DATA)
      })
  },

  // Выбор текущего аккаунта Яндекс.Директ
  [type.SELECT_ACCOUNT]: ({ getters, commit, dispatch }, { userId, username, directLogin }) => {
    const name = type.SESSION
    dispatch(type.LOADING_DATA, i18n.t('c.loading.messageDataUpdate'))

    commit(type.LOADING, name)
    return getters.apiService
      .selectAccount({ userId, username, directLogin })
      .then(() => {
        saveStorageItem(DIRECT_LOGIN, directLogin)
      })
      .catch(throwError(commit, 'Ошибка выбора аккаунта'))
      .finally(() => {
        commit(type.LOADED, name)
        dispatch(type.LOADED_DATA)
      })
  }
}
